export default __webpack_public_path__ + "static/concordia-2406a9e851f13d23ee72e3672e24e2ae.png";